import * as R from 'ramda';

import { HttpService } from '~/services';
import {
  getRouteNavigationParamsWithFormattedDate,
  renameKeys,
} from '~/helpers';

export const resolvers = {
  Query: {
    otherPlatformsTrxList: async (
      _, // eslint-disable-line no-unused-vars
      props,
      { cache },
    ) => {
      const columnsMapping = {
        DateTimeUtc: 'date',
        PlatformName: 'platformName',
        TrxId: 'trxId',
        TrxType: 'trxType',
        TrxFlowType: 'trxFlowType',
        AmountUsd: 'amountUsd',
        AmountMbtc: 'amountMbtc',
      };

      const params = getRouteNavigationParamsWithFormattedDate(
        {
          date: ['DateFromUtc', 'DateToUtc'],
          platformName: 'PlatformType',
          trxId: 'TrxId',
          trxType: 'TrxType',
          trxFlowType: 'TrxFlowType',
          amountUsd: ['AmountUsdFrom', 'AmountUsdTo'],
          amountMbtc: ['AmountMbtcFrom', 'AmountMbtcTo'],
        },
        R.invertObj(columnsMapping),
      )(props);

      const {
        data: { UsageList, PageCount, TotalSpend, TotalEarned },
      } = await HttpService.client.get('/MyWealth/Others/GetMbtcUsageTrxList', {
        params,
      });

      const items = R.map(
        R.pipe(
          renameKeys(columnsMapping),
          R.evolve({
            amountUsd: parseFloat,
            amountMbtc: parseFloat,
          }),
          R.assoc('__typename', 'OtherPlatformsTrxItems'),
        ),
        UsageList,
      );

      const otherPlatformsTrxList = {
        data: items,
        pages: PageCount,
        totalSpend: parseFloat(TotalSpend),
        totalEarned: parseFloat(TotalEarned),
        __typename: 'OtherPlatformsTrxList',
      };

      cache.writeData({ data: { otherPlatformsTrxList }, variables: props });

      return otherPlatformsTrxList;
    },

    platformTypeList: async (_, __, { cache }) => {
      const {
        data: { PlatformList },
      } = await HttpService.client.get('/MyWealth/Others/GetPlatformList');

      const platformList = R.map(
        R.pipe(
          renameKeys({
            Value: 'value',
            Name: 'name',
          }),
          R.assoc('__typename', 'PlatformTypeList'),
        ),
        PlatformList,
      );

      cache.writeData({
        data: { platformList },
      });

      return platformList;
    },

    trxTypeList: async (_, __, { cache }) => {
      const {
        data: { TrxType },
      } = await HttpService.client.get('/MyWealth/Others/GetTrxType');

      const trxTypeList = R.map(
        R.pipe(
          renameKeys({
            Value: 'value',
            Name: 'name',
          }),
          R.assoc('__typename', 'TrxTypeList'),
        ),
        TrxType,
      );

      cache.writeData({
        data: { trxTypeList },
      });

      return trxTypeList;
    },

    trxFlowTypeList: async (_, __, { cache }) => {
      const {
        data: { TrxFlowType },
      } = await HttpService.client.get('/MyWealth/Others/GetTrxFlowType');

      const trxFlowTypeList = R.map(
        R.pipe(
          renameKeys({
            Value: 'value',
            Name: 'name',
          }),
          R.assoc('__typename', 'TrxTypeList'),
        ),
        TrxFlowType,
      );

      cache.writeData({
        data: { trxFlowTypeList },
      });

      return trxFlowTypeList;
    },
  },
};
